<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useRouter } from "vue-router"
import { useI18n } from "vue-i18n"
import type { BreadcrumbItem } from "@core/components/layout/header/HeaderPage.vue"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Grouper des bâtiments",
            breadcrumbHome: "Accueil",
        },
    },
})

// ================================
// ROUTER
// ================================
const router = useRouter()

// ================================
// COMPUTED
// ================================
const getBreadcrumb = computed<BreadcrumbItem[]>(() => [
    { label: t("breadcrumbHome"), icon: "pi pi-home", route: "/" },
    { label: t("title") },
])

// ================================
// HANDLERS
// ================================
/**
 * Après création du groupe : navigation vers le bâtiment créé.
 */
function onDone(payload: { _id_building: string }): void {
    const id = payload._id_building
    if (!id) return
    router.push({ path: `/building/${id}` })
}

/**
 * Annulation : retour accueil.
 */
function onCancel(): void {
    router.push({ path: "/" })
}
</script>

<template>
    <div class="page page-building-group">
        <HeaderPage :title="t('title')" :breadcrumb="getBreadcrumb" />

        <BaseCard class="mx-auto w-full max-w-screen-lg p-6">
            <template #content>
                <BuildingGroupForm
                    class="mx-auto"
                    @done="onDone"
                    @cancel="onCancel"
                />
            </template>
        </BaseCard>
    </div>
</template>
